import { useMemo } from "react";

import { EditAppointmentContent } from "@/constants/EditEvents";
import type { EditAppointmentScope } from "@/constants/EditEvents";
import AvailabilityTimeSlotList from "@/ui/components/schedule/booking/availability/AvailabilityTimeSlotList";
import BookingTitleHeader from "@/ui/components/schedule/booking/BookingTitleHeader";
import { Box } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface RescheduleAvailabilityCardProps {
  onLoadingChange: (isLoading: boolean) => void;
  onTimeSlotSelect: (timeSlot?: TimeSlot) => void;
  scope: EditAppointmentScope;
}
const RescheduleAvailabilityCard = ({
  onLoadingChange,
  onTimeSlotSelect,
  scope,
}: RescheduleAvailabilityCardProps) => {
  const baseTestID = "appointment-reschedule-overview-card";

  const { availabilityDescription } = EditAppointmentContent[scope];

  const ListHeaderComponent = useMemo(
    () => (
      <BookingTitleHeader
        testID={joinTestIDs(baseTestID, "header")}
        title={availabilityDescription}
      />
    ),
    [availabilityDescription],
  );

  return (
    <Box flex={1}>
      <AvailabilityTimeSlotList
        isInsideBottomSheet
        ListHeaderComponent={ListHeaderComponent}
        onLoadingChange={onLoadingChange}
        onTimeSlotSelect={onTimeSlotSelect}
        shouldIgnoreRecurrence={scope === "appointment"}
        shouldRemoveHorizontalPadding
        testID={baseTestID}
      />
    </Box>
  );
};

export type { RescheduleAvailabilityCardProps };

export default RescheduleAvailabilityCard;
